import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import type { components } from "@shared/api-types";
import { request } from "@/api/client";

/**
 * DUE-429 — background jobs overview. Mirrors `AdminJobsDTO`
 * (`src/api/schemas/admin_jobs.py`, generated into `shared/api-types.ts`).
 */

export type AdminJobs = components["schemas"]["AdminJobsDTO"];

export const JobRunSchema = z.object({
  job_id: z.string(),
  slot: z.string(),
  owner: z.string(),
  status: z.string(),
  started_at: z.string(),
  finished_at: z.string().nullable(),
  duration_seconds: z.number().nullable(),
  result: z.record(z.unknown()).nullable(),
});

export const AdminJobsSchema = z.object({
  jobs: z.array(
    z.object({
      job_id: z.string(),
      last: JobRunSchema.nullable(),
      recent: z.array(JobRunSchema),
      ok_share_7d: z.number().nullable(),
    }),
  ),
}) satisfies z.ZodType<AdminJobs>;

export function useAdminJobs() {
  return useQuery({
    queryKey: ["admin", "jobs"],
    queryFn: ({ signal }) =>
      request({ path: "/api/admin/jobs", schema: AdminJobsSchema, signal }),
  });
}
